<section class="about-header section-main-padding">
  <h1 class="page-title">About Us</h1>
  <div class="about-content">
    <div class="about-image">
      <img src="assets/images/about-img.png" alt="About Herbs.LYF">
    </div>
    <div class="about-text">
      <h3>Power of Nature</h3>
      <h2>Why go the Ayurveda Way?</h2>
      <p>
        If we split AYURVEDA into two parts, two words come out i.e., "AYUR" means life & "VEDA" means knowledge of
        life. It's a complete package of Indian remedies for our Spiritual, Physical, and Mental health. We have three
        types of dosha in Ayurveda - KAPHA(EARTH), PITTA(FIRE), and VATTA(WIND). Every medicine at
        <span class="text-herbs">Herbs.</span><span class="text-lyf">LYF<sup>®</sup></span> is geared
        towards bringing one of these forces into harmony in the body.
      </p>
    </div>
  </div>
</section>

<section class="benefits-section">
  <div class="container">
    <div class="section-title">
      <h2>Benefits of Ayurveda</h2>
    </div>

    <div class="benefits-grid">
      <div class="benefit-item">
        <div class="benefit-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
            <path d="M2 17l10 5 10-5"></path>
            <path d="M2 12l10 5 10-5"></path>
          </svg>
        </div>
        <h3>More affordable than conventional medicine</h3>
      </div>

      <div class="benefit-item">
        <div class="benefit-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M16 12l-4 4-4-4m0 0l4-4 4 4"></path>
          </svg>
        </div>
        <h3>Easier to obtain than prescription medicine</h3>
      </div>

      <div class="benefit-item">
        <div class="benefit-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5l6.74-6.76z"></path>
            <line x1="16" y1="8" x2="2" y2="22"></line>
            <line x1="17.5" y1="15" x2="9" y2="15"></line>
          </svg>
        </div>
        <h3>Stabilizes hormones and your metabolism</h3>
      </div>

      <div class="benefit-item">
        <div class="benefit-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
            <polyline points="9 22 9 12 15 12 15 22"></polyline>
          </svg>
        </div>
        <h3>Natural healing and fewer adverse effects</h3>
      </div>

      <div class="benefit-item">
        <div class="benefit-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
          </svg>
        </div>
        <h3>Strengthens your immune system naturally</h3>
      </div>
    </div>
  </div>
</section>

<section class="growing-section">
  <div class="container">
    <div class="growing-content">
      <div class="growing-text">
        <h3>Power of Nature</h3>
        <h2>Growing Use of Herbal</h2>
        <p>
          Over the past three decades, the usage of herbal medicines and supplements has grown significantly, with at
          least 80% of people turning to them for some aspect of primary health care.
        </p>
        <!-- <a routerLink="/shop" class="btn theme-btn">Buy Now</a> -->
        <app-buy-now-button></app-buy-now-button>
      </div>
    </div>
  </div>
</section>

<section class="mission-section">
  <div class="container">
    <div class="mission-content">
      <div class="mission-left">
        <h3>Our Formula</h3>
        <h2>We Promote and Nurture the Sustenance of the Life Force itself through the Power of Nature.</h2>
      </div>

      <div class="mission-right">
        <h3><span class="text-herbs">Herbs.</span><span class="text-lyf">LYF<sup>®</sup></span> Mission & Vision</h3>
        <p>
          We emulate the world's oldest holistic healing system. Our formula is to use only the best natural herbs and
          sources, suitable to enhance human vitality and help them live a healthy and happy life.
        </p>
        <p>
          We have acquired an understanding of human life and what it requires, therefore we ensure the production of
          top-quality products which are safe and consistent.
        </p>
      </div>
    </div>
  </div>
</section>
<app-gallery></app-gallery>